import { CommonMsgNodeProps, WaitingMessageType } from '@/types/message'
import clockPng from './clock.png'
import styles from './index.module.scss'
import Card from '@/components/chat-card'

interface WaitingProps extends CommonMsgNodeProps {
  node: WaitingMessageType
}

export const Waiting = (props: WaitingProps) => {
  const { node } = props
  const { text = '正在等待审核' } = node.value

  return (
    <Card className={styles.container}>
      <img src={clockPng} alt="clock" className={styles.clock} />
      <p className={styles.text}>{text}</p>
    </Card>
  )
}

export default Waiting
